import {
    Button,
    Form,
    Field,
    Toast,
    Icon,
    List,
    Cell,
    Loading,
    Swipe,
    SwipeItem,
    Popup,
    RadioGroup,
    Radio,
    Stepper,
    Picker,
    Collapse,
    CollapseItem,
    Dialog,
    Empty,
    Calendar,
    DatetimePicker,
    CheckboxGroup,
    Checkbox,
    Divider,
    Space
} from 'vant'

export default [
    Button,
    Form,
    Field,
    Toast,
    Icon,
    List,
    Cell,
    Loading,
    Swipe,
    SwipeItem,
    Popup,
    RadioGroup,
    Radio,
    Stepper,
    Picker,
    Collapse,
    CollapseItem,
    Dialog,
    Empty,
    Calendar,
    DatetimePicker,
    CheckboxGroup,
    Checkbox,
    Divider,
    Space
]